<template>
  <div class="popup">
    <h1 class="title">{{ popup.title }}</h1>
    <p class="text">{{ popup.address }}</p>
    <p class="text">SAN DIEGO, CA 92101</p>
    <p class="text" v-if="popup.link">
      <a :href="popup.link" target="_blank" rel="noopener">Website</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Popup",
  props: ["popup"]
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.mapboxgl-popup-content {
  background: $gold;
  padding: 1rem;
}

.mapboxgl-popup-tip {
  border-top-color: $gold !important;
}
</style>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.popup {
  text-align: center;
}

.title {
  font: bold 1.25rem $courier;
  color: $black;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.text {
  margin: 0;
  font: normal 1rem "Adobe Caslon Pro";
  color: $black;
}

.text a {
  color: $black;
}

.text:last-of-type {
  margin-top: 0.5rem;
}
</style>
